<table class="table participants">
    <thead>
        <tr>
            <th></th>
            <th></th>
            <th>{{ 'form.name-and-surname' | translate }}</th>
            <th class="d-none d-md-table-cell">
                {{ 'form.document' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.phone' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.condition' | translate }}
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-template ngFor let-participant [ngForOf]="participants" let-isFirst="first">
            <tr [class.gray]="participant.legalGuardians && participant.legalGuardians.length > 0">
                <td [ngSwitch]="participant.type">
                    <i class="icon-legal" *ngSwitchCase="ClientType.LEGAL_PERSON"></i>
                    <i class="icon-minor-plus" *ngSwitchCase="ClientType.MINOR"></i>
                    <i class="icon-disabled-plus" *ngSwitchCase="ClientType.DISABLED"></i>
                    <i class="icon-natural-plus" *ngSwitchDefault></i>
                </td>
                <td></td>
                <td>
                    <strong>{{ participant.name }}</strong
                    >&nbsp;<strong>{{ participant.surname }}</strong>
                </td>
                <td class="d-none d-md-table-cell">
                    <strong>{{ participant.docId }}</strong>
                </td>
                <td class="d-none d-md-table-cell">
                    <strong>{{ participant.phone }}</strong>
                </td>
                <td class="d-none d-md-table-cell" [ngSwitch]="participant.type">
                    <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.MINOR">
                        {{ 'form.minor-person' | translate }}
                    </strong>
                    <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.DISABLED">
                        {{ 'form.disabled-person' | translate }}
                    </strong>
                    <strong *ngSwitchDefault> - </strong>
                </td>
            </tr>
            <ng-template ngFor let-legalGuardian [ngForOf]="participant.legalGuardians" let-isFirstLG="first" let-isLastLG="last">
                <tr [class.gray]="!isLastLG">
                    <td></td>
                    <td>
                        <span *ngIf="isFirstLG && participant.type === ClientType.DISABLED && participant.legalGuardians.length > 1"
                            >{{ 'form.representatives' | translate }}:</span
                        >
                        <span *ngIf="isFirstLG && participant.type === ClientType.DISABLED && participant.legalGuardians.length === 1"
                            >{{ 'form.the-representative' | translate }}:</span
                        >
                        <span *ngIf="isFirstLG && participant.type === ClientType.MINOR && participant.legalGuardians.length > 1"
                            >{{ 'form.tutors' | translate }}:</span
                        >
                        <span *ngIf="isFirstLG && participant.type === ClientType.MINOR && participant.legalGuardians.length === 1"
                            >{{ 'form.the-tutor' | translate }}:</span
                        >
                    </td>
                    <td>
                        <strong>{{ legalGuardian.name }}</strong
                        >&nbsp;<strong>{{ legalGuardian.surname }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ legalGuardian.docId }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ legalGuardian.phone }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell"></td>
                </tr>
            </ng-template>
        </ng-template>
    </tbody>
</table>
